[
  {
    "code": "+34",
    "label": {
      "en": "+34 (Spain)"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XXX XXX"
    }
  },
  {
    "code": "+33",
    "label": {
      "en": "+33 (France)"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "format": "+XX X XX XX XX XX"
    }
  },
  {
    "code": "+49",
    "label": {
      "en": "+49 (Germany)"
    },
    "order": 3,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XXXXXXX"
    }
  },
  {
    "code": "+39",
    "label": {
      "en": "+39 (Italy)"
    },
    "order": 4,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XXX XXXX"
    }
  },
  {
    "code": "+351",
    "label": {
      "en": "+351 (Portugal)"
    },
    "order": 5,
    "is_active": true,
    "metadata": {
      "format": "+XXX XXX XXX XXX"
    }
  },
  {
    "code": "+44",
    "label": {
      "en": "+44 (UK)"
    },
    "order": 6,
    "is_active": true,
    "metadata": {
      "format": "+XX XXXX XXXXXX"
    }
  },
  {
    "code": "+353",
    "label": {
      "en": "+353 (Ireland)"
    },
    "order": 7,
    "is_active": true,
    "metadata": {
      "format": "+XXX XX XXX XXXX"
    }
  },
  {
    "code": "+31",
    "label": {
      "en": "+31 (Netherlands)"
    },
    "order": 8,
    "is_active": true,
    "metadata": {
      "format": "+XX X XXXX XXXX"
    }
  },
  {
    "code": "+32",
    "label": {
      "en": "+32 (Belgium)"
    },
    "order": 9,
    "is_active": true,
    "metadata": {
      "format": "+XX X XXX XX XX"
    }
  },
  {
    "code": "+41",
    "label": {
      "en": "+41 (Switzerland)"
    },
    "order": 10,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXX XX XX"
    }
  },
  {
    "code": "+43",
    "label": {
      "en": "+43 (Austria)"
    },
    "order": 11,
    "is_active": true,
    "metadata": {
      "format": "+XX X XXXX XXXX"
    }
  },
  {
    "code": "+46",
    "label": {
      "en": "+46 (Sweden)"
    },
    "order": 12,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXX XX XX"
    }
  },
  {
    "code": "+47",
    "label": {
      "en": "+47 (Norway)"
    },
    "order": 13,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XX XXX"
    }
  },
  {
    "code": "+45",
    "label": {
      "en": "+45 (Denmark)"
    },
    "order": 14,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XX XX XX"
    }
  },
  {
    "code": "+358",
    "label": {
      "en": "+358 (Finland)"
    },
    "order": 15,
    "is_active": true,
    "metadata": {
      "format": "+XXX XX XXX XXXX"
    }
  },
  {
    "code": "+48",
    "label": {
      "en": "+48 (Poland)"
    },
    "order": 16,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XXX XXX"
    }
  },
  {
    "code": "+1",
    "label": {
      "en": "+1 (USA/Canada)"
    },
    "order": 17,
    "is_active": true,
    "metadata": {
      "format": "+X (XXX) XXX-XXXX"
    }
  },
  {
    "code": "+52",
    "label": {
      "en": "+52 (Mexico)"
    },
    "order": 18,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXXX XXXX"
    }
  },
  {
    "code": "+54",
    "label": {
      "en": "+54 (Argentina)"
    },
    "order": 19,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXXX XXXX"
    }
  },
  {
    "code": "+55",
    "label": {
      "en": "+55 (Brazil)"
    },
    "order": 20,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXXXX XXXX"
    }
  },
  {
    "code": "+57",
    "label": {
      "en": "+57 (Colombia)"
    },
    "order": 21,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XXX XXXX"
    }
  },
  {
    "code": "+56",
    "label": {
      "en": "+56 (Chile)"
    },
    "order": 22,
    "is_active": true,
    "metadata": {
      "format": "+XX X XXXX XXXX"
    }
  },
  {
    "code": "+51",
    "label": {
      "en": "+51 (Peru)"
    },
    "order": 23,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XXX XXX"
    }
  },
  {
    "code": "+86",
    "label": {
      "en": "+86 (China)"
    },
    "order": 24,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XXXX XXXX"
    }
  },
  {
    "code": "+81",
    "label": {
      "en": "+81 (Japan)"
    },
    "order": 25,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXXX XXXX"
    }
  },
  {
    "code": "+82",
    "label": {
      "en": "+82 (South Korea)"
    },
    "order": 26,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXXX XXXX"
    }
  },
  {
    "code": "+91",
    "label": {
      "en": "+91 (India)"
    },
    "order": 27,
    "is_active": true,
    "metadata": {
      "format": "+XX XXXXX XXXXX"
    }
  },
  {
    "code": "+65",
    "label": {
      "en": "+65 (Singapore)"
    },
    "order": 28,
    "is_active": true,
    "metadata": {
      "format": "+XX XXXX XXXX"
    }
  },
  {
    "code": "+971",
    "label": {
      "en": "+971 (UAE)"
    },
    "order": 29,
    "is_active": true,
    "metadata": {
      "format": "+XXX XX XXX XXXX"
    }
  },
  {
    "code": "+966",
    "label": {
      "en": "+966 (Saudi Arabia)"
    },
    "order": 30,
    "is_active": true,
    "metadata": {
      "format": "+XXX XX XXX XXXX"
    }
  },
  {
    "code": "+972",
    "label": {
      "en": "+972 (Israel)"
    },
    "order": 31,
    "is_active": true,
    "metadata": {
      "format": "+XXX XX XXX XXXX"
    }
  },
  {
    "code": "+90",
    "label": {
      "en": "+90 (Turkey)"
    },
    "order": 32,
    "is_active": true,
    "metadata": {
      "format": "+XX XXX XXX XXXX"
    }
  },
  {
    "code": "+61",
    "label": {
      "en": "+61 (Australia)"
    },
    "order": 33,
    "is_active": true,
    "metadata": {
      "format": "+XX X XXXX XXXX"
    }
  },
  {
    "code": "+64",
    "label": {
      "en": "+64 (New Zealand)"
    },
    "order": 34,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXX XXXX"
    }
  },
  {
    "code": "+27",
    "label": {
      "en": "+27 (South Africa)"
    },
    "order": 35,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXX XXXX"
    }
  },
  {
    "code": "+20",
    "label": {
      "en": "+20 (Egypt)"
    },
    "order": 36,
    "is_active": true,
    "metadata": {
      "format": "+XX XX XXX XXXX"
    }
  }
]
